import urls from '@app/plugins/urls'
import { kintoneHealthModule } from '@app/store'
import { reportKintoneOutageRedirect } from '@app/utils/kintoneOutageReport'

export default async function ({
  route,
  redirect,
}: {
  route: { path: string; fullPath: string }
  redirect: any
}) {
  // 障害ページ自身は除外する。除外しないと ng のまま自分自身へ
  // リダイレクトし続ける（自己リダイレクトループ）。末尾スラッシュにも
  // 効くよう防御的に正規化する。
  const normalizedPath = route.path.replace(/\/+$/, '') || '/'
  if (normalizedPath === urls.kintoneOutage) {
    return
  }

  await kintoneHealthModule.check()

  if (kintoneHealthModule.status === 'ng') {
    // 復帰先はクエリを含める。クエリを落とすと、復旧後の「再試行する」で
    // /carepro-id/device/detail?id=... は無言で mypage へ戻され、
    // /carepro-id/action?oobCode=... は invalid url で失敗する。
    kintoneHealthModule.setBlockedFrom(route.fullPath)
    // Sentry へ送るのは path のみ。fullPath には oobCode（Firebase の
    // アクションコード）や device_id が載りうるため、外部へ出さない。
    reportKintoneOutageRedirect(route.path)
    redirect(urls.kintoneOutage)
  }
}
